import React, { Component } from 'react';
import T from 'i18n-react';
import configureT from './configureT';
import PaymentIntoduction from './PaymentIntoduction';
import PaymentForm from './PaymentForm';
import SuccessInfo from './SuccessInfo';
import { graphql, compose, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import Spinner from './Spinner'
import message from './Message';
import 'url-search-params-polyfill';

const avaliableStates = [
  'b5_pending_refund_to_pax',
  'b5_pending_refund_reminder1',
  'b5_pending_refund_reminder2',
  'c7_pending_refund_to_pax',
  'c7_pending_refund_reminder1',
  'c7_pending_refund_reminder2'
];

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorInfo: false,
      successInfo: false,
      alreadyCompleted: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && !this.props.data.payment && nextProps.data.payment) {
      configureT(nextProps.data.payment.passengerTicket.passengerLanguage, 'payment')
    }
  }

  showSuccessInfo=()=>{
    this.setState({successInfo: true});
    setTimeout(() => {
      this.setState({successInfo: false, alreadyCompleted: true});
    }, 1500);
  }

  handleSubmit = (inputData) => {
    this.props.client.mutate({
      mutation: SendPayment,
      variables: {
        input: {
          ...inputData,
          token: urlParams.get('id')
        }
      }
    }).then(({ data }) => {
      this.setState({successInfo: true})
    }).catch((error) => {
      console.dir(error)
      this.setState({errorInfo: true});
      window.scrollTo(0,0)
    });
  }

  render() {
    const { loading, payment } = this.props.data;
    let language;
    if(this.props.data.payment){
      language=this.props.data.payment.passengerTicket.passengerLanguage;
      if(this.props.data.payment.passengerTicket.passengerLanguage === "Slovak"){
        language = "English"
      }
    } else {
      language = "English"
    }
    configureT(language, 'payment')

    if(loading){
      return <Spinner />
    }else if(!payment || this.state.errorInfo){
      return message("Server error occured. Please try again later.")
    }else if (this.state.successInfo){
      return <SuccessInfo title={T.translate("successScreen")} />
    } else {
      return(
        <div>
          {
            avaliableStates.includes(payment.claim.crmState) ?
              <div className="container-external">
                <PaymentIntoduction data={payment}/>
                <PaymentForm data={payment} handleSubmit={this.handleSubmit}/>
              </div>
              :
              message(T.translate("successScreen"), true)
          }
        </div>
      )
    }
  }
}

const urlParams = new URLSearchParams(window.location.search)

const PaymentData = gql`
  query($token: String!){
    payment(token: $token){
      affiliate {
        logoUrl,
        paypal
      }
      organisation {
        logoUrl,
        displayPaymentLogo
      }
      claim {
        id
        crmState
        codeClaim
      }
      charity {
        name
        logoUrl
        donation {
          German
          English
          Spanish
          French
          Italian
        }
      }
      passengerTicket {
        passengerFirstName
        passengerLastName
        passengerEmail
        passengerLanguage
      }
      airline
      paxPercentageCommission
      paxFlatCommission
      paxCompensationAmount
      paxToTransferAmount
      totalArRevenue
    }
  }
`

const SendPayment = gql`
  mutation Payment($input: PaymentMutationInput!){
    payment(input: $input) {
      claim { 
        id
      }
    }
  }
`

const PaymentWithData = compose(
  withApollo,
  graphql(PaymentData, {
    options: {
      variables : {
        token: urlParams.get('id')
      }
    }
  })
)(Payment)

export default PaymentWithData;


// WEBPACK FOOTER //
// ./src/components/Payment.js